import React from 'react';
import connect from "react-redux/es/connect/connect";
import { hashHistory } from 'react-router';

import { deleteEventAction } from "../../../../../actions/eventsStoreActions";

import { Form, Button, Row,  Col, Popconfirm, message } from "antd";

const DeleteButton = ({ newElement, item, noChannelsBlocker, deleteEventAction, setStateHandler }) => {
  const handleDeleteEvent = async (event) => {
    deleteEventAction(event).then((res) => {
      if (res === "success") {
        message.success('Event successful deleted');
        setStateHandler({ deletingEvent: false });

        hashHistory.push(`/Past_Events/Surgeries`);
      } else {
        message.error("Event didn't delete:", res);
        setStateHandler({ deletingEvent: false });
      }
    })
  };

  let buttonText = 'Save Changes';
  if (newElement) {
    buttonText = item.isUpcoming ? "Create Event" : "Upload Past Event"
  }

  let deleteButton = null;
  if (newElement === false) {
    deleteButton = (
      <Row type="flex" className="edit-form-button-bar">
        <Col xs={24} md={12}>
          <Form.Item className="form-center-buttons">
            <Row>
              <Col>
                <Button className="btn-danger">
                  <Popconfirm
                    title={`Are you sure delete this event - ${item.title}?`}
                    onConfirm={() => handleDeleteEvent(item)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <a href="#">Delete Event</a>
                  </Popconfirm>
                </Button>
              </Col>
            </Row>
          </Form.Item>
        </Col>
      </Row>
    );
  }

  return (
    <React.Fragment>
      <Row type="flex" className="edit-form-button-bar">
        <Col xs={24} md={12}>
          <Form.Item className="form-center-buttons">
            <Row>
              <Col>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="login-form-button"
                  disabled={noChannelsBlocker}
                >
                  {buttonText}
                </Button>
              </Col>
            </Row>
          </Form.Item>
        </Col>
      </Row>
      {deleteButton}
    </React.Fragment>
  );
};

export default connect(null, { deleteEventAction })(DeleteButton);


// WEBPACK FOOTER //
// ./src/pages/EventEditor/Content/EventForm/Buttons/index.js